import React, {Component} from 'react';
import {connect} from "react-redux";

class Schedule extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
        }

    }

    componentWillMount() { 
    }

    componentDidMount() {
    }
  
    componentWillUnmount() {
        
    }
  
    componentWillReceiveProps(newProps) {

    }

    componentDidUpdate() {
       
    }
  
    render() {
        return (
            <div className="container">
                <h4 className="mt-4 mb-4">{this.props.scheduleCaption}</h4>
                <div className="section lang-info">
                    <div className="tabbable-line nav-justified">
                        <ul className="nav nav-tabs tab-nav nav-justified">
                        {this.props.schedules.map((schedule, key) => (
                            <li className={key === 0 ? 'active' : ''} key={key}>
                                <a href={'#tab_' + key} data-toggle="tab" className={key === 0 ? 'active show' : 'show'} dangerouslySetInnerHTML={{__html: schedule.title}}>
                                </a>
                            </li>
                        ))}
                        </ul>
                    </div>
                </div>        
                <div className="tab-content">
                    {this.props.schedules.map((schedule, key) => (
                    <div className={key === 0 ? 'active tab-pane' : 'tab-pane'} id={'tab_' + key} key={key}>
                        <div dangerouslySetInnerHTML={{__html: schedule.description}}>
                        </div>
                    </div>
                    ))}

                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { 
        language: state.language
    };
}

export default connect(mapStateToProps)(Schedule);